import { css } from '@emotion/react';
import React from 'react';
import { useDispatch } from 'react-redux';
import { Switch, Route, Redirect } from 'react-router-dom';

import { AUTH_REQUEST } from './redux/auth';
import { loading } from './assets/styles/loading';
import { useAppSelector } from './hooks';
import AppointmentList from './components/AppointmentList';
import RxType from './components/RxType';
import UploadReading from './components/UploadReading';
import { ROUTE_ADD_RX, ROUTE_UPLOAD_READING, ROUTE_ROOT } from './routes';

const App = () => {
  const { me, jwt, error } = useAppSelector(state => state.auth);
  const dispatch = useDispatch();

  if (!jwt) {
    dispatch({ type: AUTH_REQUEST });
    return (
      <div css={loading}>
        <img
          alt="spinner"
          src="https://www.warbyparker.com/assets/img/icons/actions/spinner.png"
        />
        <p>Loading&hellip;</p>
      </div>
    );
  }

  if (!me) {
    return (
      <div css={loading}>
        <img
          alt="spinner"
          src="https://www.warbyparker.com/assets/img/icons/actions/spinner.png"
        />
        <p>Loading&hellip;</p>
      </div>
    );
  }

  if (error) {
    return <h1>{error}</h1>;
  }

  return (
    <div css={css`padding-bottom: 100px;`}>
      <Switch>
        <Route path={ROUTE_ROOT} component={AppointmentList} exact />
        <Route path={`${ROUTE_ADD_RX}/:appointmentId`} component={RxType} exact />
        <Route path={`${ROUTE_UPLOAD_READING}/:appointmentId`} component={UploadReading} exact />
      </Switch>
      <Redirect from="*" to={ROUTE_ROOT} />
    </div>
  );
};

export default App;
